module.exports = __webpack_public_path__ + "img/wallpaper-11.b5add85f.jpg";